import React from "react";
import {IonIcon} from "@ionic/react";
import Col from "./Col";
import {dateToHuman2Year, logBookDayToFlyDayParam, parseLogBookDay} from "../common/TimeUtils";
import {create} from "ionicons/icons";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {filterGlider} from "../reduce/actions";

export const LogbookItem =  ({item, hideParts, setEditItem=f=>f, glider}) =>
{
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const changeFlyDay = (day) => {
      const dateParam = logBookDayToFlyDayParam(day);
      if (!dateParam) return;
      navigate('/flyday/' + dateParam);
      dispatch(filterGlider(glider));
  }

  const takeOffName = item.takeOffPlaceName
      ?? (item.takeOffPlace && item.takeOffPlace.name)
      ?? '';
  const landingName = item.landingPlaceName
      ?? (item.landingPlace && item.landingPlace.name)
      ?? '';

  const parsedDay = parseLogBookDay(item.day);

  return (
      <tr key={item.id} className={item.incompleteTime ? 'incomplete':''}>
          <Col>
            {parsedDay ? (
              <span className={'btn-link'} onClick={() => changeFlyDay(item.day)}>{dateToHuman2Year(parsedDay)}</span>
            ) : (
              <span>{String(item.day ?? '')}</span>
            )}
            {item.manual && <IonIcon icon={create} className={'edit-icon'} onClick={() => setEditItem(item)}/>}
          </Col>
          <Col>{takeOffName} - {landingName}{item.incompleteTime && <div>Chybí čas přistání</div>}</Col>
        <Col className={!hideParts ? 'hide' : 'show-column'}>&nbsp;</Col>
        <Col className={hideParts ? 'hide-part':''}>?</Col>
        <Col className={hideParts ? 'hide-part':''}>?</Col>
        <Col>{item.winch ? 'N': 'A'}</Col>
        <Col>{item.count}</Col>
        <Col>{item.hours}</Col>
        <Col>{item.minutes}</Col>
        <Col>{item.totalCount}</Col>
        <Col>{item.totalHours}</Col>
        <Col>{item.totalMinutes}</Col>
      </tr>
  )
};
